<app-modal-frame
  [headerText]="
    this.data.type === POPUP_TYPE.DELIVERY
      ? CONSTANTS.ADD_DELIVERY
      : CONSTANTS.ADD_STOP
  "
  [leftButton]="{
    text: CONSTANTS.BACK,
    disable: false,
    type: BUTTON_TYPES.NONE,
  }"
  [rightButton]="{
    text: LABELS.ADD,
    disable: addStopForm.invalid,
    type: BUTTON_TYPES.TEXT_BUTTON,
  }"
  (emitExit)="onClose()"
  (emitLeftClick)="onBack()"
  (emitRightClick)="sendAddStopEvent()"
>
  <div class="popup-content">
    <form [formGroup]="addStopForm">
      <!------ Route + Date -------->

      <ion-row class="section-one">
        <!-- Route -->
        <ion-col size="2">
          <app-form-text-field
            [labelText]="LABELS.ROUTE"
            [form]="addStopForm"
            [control]="'route'"
            [maxLength]="3"
            [hasRequiredSign]="false"
            [regexType]="NO_SPACES"
            [autoCapitalizeCharacters]="true"
          ></app-form-text-field>
        </ion-col>

        <!-- Plan Date -->
        <ion-col size="3">
          <div class="form-group">
            <label class="big-label">{{ LABELS.PLAN_DATE }} </label>
          </div>
          <app-form-date-picker
            [value]="data.planDate"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [customClass]="'form-date-picker'"
            [formControlName]="'planDate'"
          ></app-form-date-picker>
        </ion-col>

        <!-- Stop Type -->
        <ion-col size="4" class="radio-group">
          <div class="radio-label">
            <span>{{ LABELS.STOP_TYPE }}</span>
            <span class="required-field">*</span>
          </div>
          <ion-radio-group
            formControlName="stopTimeType"
            class="radio-group"
            (ionChange)="updateRadioGroup()"
          >
            <ion-radio
              class="radio-btn"
              labelPlacement="end"
              slot="start"
              [value]="RADIO_LABELS.PLANNED"
            >
              {{ CONSTANTS.PLANNED_STOP }}
            </ion-radio>
            <ion-radio
              class="radio-btn"
              slot="start"
              labelPlacement="end"
              [value]="RADIO_LABELS.COMPLETE"
            >
              {{ CONSTANTS.COMPLETE_STOP }}
            </ion-radio>
          </ion-radio-group>
        </ion-col>
      </ion-row>

      <!-------------------------------->
      <div class="section-two">
        <ion-row>
          <!-- Consignee -->
          <ion-col size="6">
            <app-form-text-field
              [labelText]="LABELS.CONSIGNEE"
              [form]="addStopForm"
              [control]="'consignee'"
              [maxLength]="25"
              [regexType]="DOT_REGEX"
              [autoCapitalizeCharacters]="true"
            ></app-form-text-field>
          </ion-col>

          <!-- Number -->
          <ion-col size="6">
            <app-form-text-field
              [labelText]="LABELS.NUMBER"
              [form]="addStopForm"
              [control]="'number'"
              [maxLength]="11"
              [regexType]="DOT_REGEX"
              [autoCapitalizeCharacters]="true"
            ></app-form-text-field>
          </ion-col>
        </ion-row>
        <ion-row>
          @if (addStopForm.get("consignee")?.hasError("invalidCharacters")) {
            <div class="error-text">
              {{ ERRORS.SPECIAL_CHARACTERS_VALIDATION }}
            </div>
          }
        </ion-row>
        <ion-row>
          @if (addStopForm.get("consignee")?.hasError("maxLengthExceeded")) {
            <div class="error-text">
              {{ ERRORS.MAX_LENGTH_CONSIGNEE_VALIDATION }}
            </div>
          }
        </ion-row>

        <!-- Address/ City Row  -->
        <ion-row>
          <!-- Address -->
          <ion-col size="7">
            <app-form-text-field
              [labelText]="LABELS.STREET_ADDRESS"
              [maxLength]="30"
              [form]="addStopForm"
              [regexType]="ADDRESS_REGEX"
              [control]="'address'"
              [autoCapitalizeCharacters]="true"
            ></app-form-text-field>
          </ion-col>

          <!-- Floor -->
          <ion-col size="2.5">
            <app-form-text-field
              [labelText]="LABELS.FLOOR"
              [form]="addStopForm"
              [control]="'floor'"
              [maxLength]="3"
              [regexType]="DOT_REGEX"
              [autoCapitalizeCharacters]="true"
            ></app-form-text-field>
          </ion-col>

          <!-- Suite -->
          <ion-col size="2.5">
            <app-form-text-field
              [labelText]="LABELS.SUITE"
              [form]="addStopForm"
              [control]="'suite'"
              [maxLength]="8"
              [regexType]="DOT_REGEX"
              [autoCapitalizeCharacters]="true"
            ></app-form-text-field>
          </ion-col>
        </ion-row>

        <!-- Validations for Street Address -->
        <ion-row>
          @if (addStopForm.get("address")?.hasError("invalidCharacters")) {
            <div class="error-text">
              {{ ERRORS.SPECIAL_CHARACTERS_VALIDATION }}
            </div>
          }
        </ion-row>
        <ion-row>
          @if (addStopForm.get("address")?.hasError("maxLengthExceeded")) {
            <div class="error-text">
              {{ ERRORS.MAX_LENGTH_STREET_VALIDATION }}
            </div>
          }
        </ion-row>

        <!-- State/ Postal Code -->
        <ion-row>
          <!-- City -->
          <ion-col size="6">
            <app-form-text-field
              [labelText]="LABELS.CITY"
              [maxLength]="30"
              [form]="addStopForm"
              [regexType]="DOT_REGEX"
              [control]="'city'"
              [autoCapitalizeCharacters]="true"
            ></app-form-text-field>
          </ion-col>

          <!-- State/Province -->
          <ion-col size="3">
            <app-form-text-field
              [labelText]="LABELS.STATE"
              [minLength]="2"
              [maxLength]="2"
              [form]="addStopForm"
              [regexType]="ALPHA_REGEX"
              [control]="'state'"
              [autoCapitalizeCharacters]="true"
              [hasRequiredSign]="countryCode$.value !== 'HR'"
            ></app-form-text-field>
          </ion-col>

          <!-- Postal Code -->
          <ion-col size="3">
            <app-form-text-field
              [labelText]="LABELS.POSTAL_CODE"
              [maxLength]="8"
              [form]="addStopForm"
              [regexType]="REGEX"
              [control]="'postalCode'"
              [autoCapitalizeCharacters]="true"
            ></app-form-text-field>
            @if (
              addStopForm.get("postalCode")?.invalid &&
              addStopForm.get("postalCode")?.errors?.["nonCanadianPostal"]
            ) {
              <div class="required-field">
                {{ ERRORS.CANADIAN_POSTAL_ERROR }}
              </div>
            }
            @if (addStopForm.get("postalCode")?.hasError("maxlength")) {
              <div class="error-text">
                {{ ERRORS.MAX_LENGTH_VALUE_POSTAL_CODE }}
              </div>
            }
          </ion-col>
        </ion-row>

        <!-- Longitude/Latitude row -->
        <ion-row>
          <!-- Country -->
          <ion-col size="2">
            <app-form-text-field
              [labelText]="LABELS.COUNTRY"
              [maxLength]="30"
              [form]="addStopForm"
              [regexType]="REGEX"
              [control]="'country'"
              [readonly]="true"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </ion-col>

          <!-- Longitude -->
          <ion-col size="3">
            <app-form-text-field
              [labelText]="LABELS.LONGITUDE"
              [maxLength]="30"
              [form]="addStopForm"
              [regexType]="REGEX"
              [control]="'longitude'"
              [readonly]="true"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </ion-col>

          <!-- Latitude -->
          <ion-col size="3">
            <app-form-text-field
              [labelText]="LABELS.LATITUDE"
              [maxLength]="30"
              [form]="addStopForm"
              [regexType]="REGEX"
              [control]="'latitude'"
              [readonly]="true"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </ion-col>
        </ion-row>

        <!-- Address book row -->
        <ion-row class="address-book-row">
          <ion-col size="3">
            <app-form-checkbox
              [label]="CONSTANTS.SAVE_TO_ADDRESS_BOOK"
              formControlName="saveToAddressBook"
            ></app-form-checkbox>
          </ion-col>

          <ion-col>
            <button [class]="'search-blue'" (click)="searchAddressBook()">
              {{ CONSTANTS.SEARCH_ADDRESS_BOOK }}
            </button>
          </ion-col>
        </ion-row>

        <!-- Address Book  -->
        @if (showAddressBook) {
          <ion-row>
            <ion-col size="12">
              <app-address-book
                [selectedConsignee]="addStopForm.get('consignee')?.value"
                [selectedAddress]="addStopForm.get('address')?.value"
                [selectedCity]="addStopForm.get('city')?.value"
                [triggerSearch]="triggerSearch"
                (addressSelected)="handleAddressSelection($event)"
              ></app-address-book>
            </ion-col>
          </ion-row>
        }
      </div>

      <!------  Add a Package row ------>
      <div class="packages">
        <span class="add-package">{{ LABELS.ADD_PACKAGE }}</span>
        @for (
          packageForm of rowFormGroup;
          track packageForm.get("trackingNumber")?.value;
          let i = $index
        ) {
          <div formArrayName="packages">
            <app-new-package-details
              [rowForm]="packageForm"
              [index]="i"
              [stopType]="addStopForm.get('stopType')?.value"
              (trackingChanged)="onTrackingChanged($event)"
              (addEvent)="addPackage()"
              (removeEvent)="removePackage(i)"
            ></app-new-package-details>
          </div>
        }
      </div>
      <!-------------------------------->
    </form>
  </div>
</app-modal-frame>
